var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "ticket-access-form",
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-stepper",
            {
              attrs: { vertical: "", "non-linear": "" },
              model: {
                value: _vm.currentStep,
                callback: function($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep"
              }
            },
            [
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 1,
                    "next-step": _vm.highestStepReached < 1,
                    "previous-step": _vm.highestStepReached > 1
                  },
                  attrs: {
                    "edit-icon": "mdi-ticket-confirmation-outline",
                    "complete-icon": "mdi-ticket-confirmation-outline",
                    complete: "",
                    editable: _vm.highestStepReached >= 1,
                    step: "1"
                  }
                },
                [
                  _vm._v(" Información general "),
                  _c("small", [
                    _vm._v(
                      " En esta sección podrás especificar los detalles de tu requerimiento. "
                    )
                  ])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _c("TicketRequirementStepOne", {
                    ref: "Step1",
                    attrs: { formValues: _vm.formValues },
                    on: {
                      getRequirementTypingSelected:
                        _vm.getRequirementTypingSelected,
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep
                    }
                  })
                ],
                1
              ),
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 2,
                    "next-step": _vm.highestStepReached < 2,
                    "previous-step": _vm.highestStepReached > 2
                  },
                  attrs: {
                    "edit-icon": "mdi-check-all",
                    "complete-icon": "mdi-check-all",
                    complete: "",
                    step: "2"
                  }
                },
                [
                  _vm._v(" Resumen del ticket de Asistencia Remota "),
                  _c("small", [
                    _vm._v(
                      " Resumen de toda la información suministrada hasta ahora "
                    )
                  ])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "2" } },
                [
                  _c("TicketRequirementStepTwo", {
                    ref: "Step2",
                    attrs: { requirementTicket: _vm.requirementTicket },
                    on: {
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep,
                      reset: function($event) {
                        return _vm.$router.push({ name: "tickets" })
                      },
                      sendRequirementTicket: _vm.sendRequirementTicket
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "error" },
          model: {
            value: _vm.errorLoadingContent,
            callback: function($$v) {
              _vm.errorLoadingContent = $$v
            },
            expression: "errorLoadingContent"
          }
        },
        [
          _vm._v(
            " Ocurrió un error obteniendo la información para la creación del ticket, por favor intente nuevamente "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.errorLoadingContent = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }